// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2E1Dt","disabled":"FileBtn_disabled__3hdQf","warn":"FileBtn_warn__2y-ce","fade":"FileBtn_fade__369Ep"};